import { Badge } from '@fluentui/react-components';
import type { MemberRole, TenantAccessVia } from '@warehouselogix/shared';

/** Member role as a Fluent badge: admin filled, manager tinted, viewer outlined. */
export function RoleBadge({ role }: { role: MemberRole }): JSX.Element {
  switch (role) {
    case 'admin':
      return (
        <Badge appearance="filled" color="brand">
          admin
        </Badge>
      );
    case 'manager':
      return (
        <Badge appearance="tint" color="informative">
          manager
        </Badge>
      );
    case 'viewer':
      return <Badge appearance="outline">viewer</Badge>;
  }
}

const VIA_LABEL: Readonly<Record<TenantAccessVia, string>> = {
  membership: 'member',
  'platform-admin': 'platform',
  'entra-fallback': 'directory role',
};

/** How the caller got in. Membership is the normal case; the other two are worth seeing. */
export function ViaBadge({ via }: { via: TenantAccessVia }): JSX.Element {
  if (via === 'membership') {
    return <Badge appearance="outline">{VIA_LABEL[via]}</Badge>;
  }
  return (
    <Badge appearance="tint" color={via === 'platform-admin' ? 'important' : 'warning'}>
      {VIA_LABEL[via]}
    </Badge>
  );
}
